var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyIls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136713)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136713)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -5,
    width: 58,
    height: 39,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.4766 -3.97119H42.614V33.0761H-12.4766V-3.97119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15.2109,
    y: -0.389648,
    width: 60.4195,
    height: 4.77569,
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15.2109,
    y: 24.9971,
    width: 60.4195,
    height: 4.77569,
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3842 9.72731L15.004 5.14014L17.6238 9.72731L22.953 9.72731L20.2884 14.3928L22.8635 18.9017H17.7134L15.0935 23.4888L12.4737 18.9017H7.14453L9.80912 14.2361L7.23404 9.72731L12.3842 9.72731ZM11.81 10.7327H8.95667L10.3833 13.2307L11.81 10.7327ZM10.9575 14.2361L12.9584 10.7327H17.0496L19.14 14.3928L17.1391 17.8962H13.0479L10.9575 14.2361ZM10.3833 15.2415L8.86716 17.8962H11.8995L10.3833 15.2415ZM13.6221 18.9017L15.0935 21.478L16.5649 18.9017H13.6221ZM18.2876 17.8962H21.1409L19.7142 15.3983L18.2876 17.8962ZM19.7142 13.3874L21.2304 10.7327H18.1981L19.7142 13.3874ZM16.4754 9.72731H13.5326L15.004 7.15095L16.4754 9.72731Z",
    fill: "#0038B8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -5,
    width: 58,
    height: 39,
    rx: 5.76455,
    stroke: "#E5E5E5",
    strokeWidth: 1.44114,
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136713"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136713"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -5,
    width: 58,
    height: 39,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIls);
export default __webpack_public_path__ + "static/media/Currency=ILS.3ab6b8efa1dbda00c607c27201921c9c.svg";
export { ForwardRef as ReactComponent };